/*eslint-disable @typescript-eslint/no-unsafe-return */
import React, { ComponentType, FunctionComponent, ReactElement } from 'react';
import { Checkbox } from 'antd';
import { TCellField, TTableColumn } from '../../models';
import { MultipleSelect, SingleSelect } from './row-select/SingleSelect';
import { Identifiable } from '@custis/common';
import { InputInteger, InputNumber } from './input-number/InputNumber';
import { DatePicker } from './date-picker';
import { TextInput } from './text-input';

const Empty: FunctionComponent = () => <div />;

export function getCellField<T extends Identifiable, TFilter, TSorting>(
  column: TTableColumn<T, TFilter, TSorting>,
): ReactElement | ComponentType {
  /* eslint-disable */
  const components: Record<TCellField, ReactElement | ComponentType<any>> = {
    number: InputNumber,
    integer: InputInteger,
    string: TextInput,
    date: DatePicker,
    checkbox: Checkbox,
    select: SingleSelect,
    'multi-select': MultipleSelect,
    'no-field': Empty,
    component: column.Component as unknown as FunctionComponent<unknown>,
  };
  if (column.fieldType) {
    return components[column.fieldType];
  }
  return <Empty />;
}

export function getFieldProps<T extends Identifiable, TFilter, TSorting>(
  column: TTableColumn<T, TFilter, TSorting>,
  props?: Record<string, unknown>,
): Record<string, unknown> {
  let postfix = '';
  if (column.fieldType && ['multi-select', 'select'].includes(column.fieldType)) {
    postfix = '-select';
  }
  if (column.fieldType === 'date') {
    postfix = '-date';
  }
  if (column.fieldType && ['multi-select', 'select', 'date'].includes(column.fieldType)) {
    return {
      store: column.store,
      dropdownClassName: (column.id as string) + postfix,
      placeholder: column.Header,
      ...column.specialProps,
    };
  }
  if (column.fieldType === 'component') {
    return { ...props, ...column.specialProps };
  }
  return {
    placeholder: column.Header,
    ...column.specialProps,
  };
}
